export const environment = {
  production: false,
  company: 'LS',
  api_server: 'https://core.lsbonus.com',
  baseUrl: 'https://lsbonus.com',
};
